
import axios from 'axios'
import resources from "./resources"
import  { 
    simulationTypes,
    opticalTypes 
} from "./types"

const API_URL = process.env.API_URL
const TOKEN_CHECK_VERB = process.env.TOKEN_CHECK_VERB
const CALCULATION_VERB = process.env.CALCULATION_VERB
const timeOut = process.env.TIMEOUT

console.log(API_URL)

const ApiService = {
    _axiosInstance: null,

    init (token) {
        this._axiosInstance = axios.create({
            baseURL: API_URL,
            timeout: timeOut,
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            crossDomain: true
        })
    },

    GetTokenApproval(token) {
        this.init(token)
        return this._axiosInstance.get(TOKEN_CHECK_VERB)
    },

    PrepareDataForCalculation(simulationType, specificData) {
        return {
            careDate:new Date().toISOString().slice(0,10),
            simulationType: simulationType,
            medicalCareData: simulationType == simulationTypes.medicalCare.code ? specificData : null,
            dentalCareData: simulationType == simulationTypes.dentalCare.code ? specificData : null,
            opticalCareData: simulationType == simulationTypes.opticalCare.code ? specificData : null,
            hospitalizationData: simulationType == simulationTypes.hospitalization.code ? specificData : null
        }
    },

    Calculate(simulationType, specificData, commit) {
        var data = this.PrepareDataForCalculation(simulationType, specificData)

        this._axiosInstance.post(CALCULATION_VERB, data)
        .then(response => {
            if (response.data.status === false)
                throw resources.response.data.errorMessage
            
            if (response.data.informations != null && 
                response.data.informations.filter(item => { return item.type == 'A' }).length > 0)
            {
                response.data.informations.filter(item => { return item.type == 'A' }).forEach(item => commit('pushError', item.message))
            } else {
                // If simulation is dental or hospitalization or lens, web services must return simpleData
                if((simulationType === simulationTypes.dentalCare.code ||
                     simulationType === simulationTypes.hospitalization.code || 
                     (simulationType === simulationTypes.opticalCare.code 
                        && specificData.opticalCareType === opticalTypes.Lens.code)) 
                    && response.data.refundSimpleData === null) {
                    throw resources.standardErrorMessage
                }

                // If simulation is medicalcare or glasses, web services must return complexData
                if((simulationType === simulationTypes.medicalCare.code
                    || (simulationType === simulationTypes.opticalCare.code 
                    && specificData.opticalCareType === opticalTypes.Glasses.code)) 
                    && response.data.refundComplexData === null) {
                    throw resources.standardErrorMessage
                }

                var results = {}
                results.simulationType = simulationType 
                results.totalSpentAmount = response.data.refundData.totalAmountSpent

                if(response.data.refundSimpleData != null) {
                    results.refundSimpleData = { 
                        socialSecurityRefundAmount: response.data.refundSimpleData.socialSecurityRefundAmount,
                        complementaryRefundAmount: response.data.refundSimpleData.complementaryRefundAmount,
                        leftToPayAmount: response.data.refundSimpleData.leftToPayAmount
                    }
                }
                
                if(response.data.refundComplexData != null) {
                    results.refundComplexData = []
                    response.data.refundComplexData.forEach(
                        element => { if(element.type) {
                            results.refundComplexData.push({
                                type: element.type,
                                socialSecurityRefundAmount: element.socialSecurityRefundAmount,
                                complementaryRefundAmount: element.complementaryRefundAmount,
                                leftToPayAmount: element.leftToPayAmount
                            })
                        }
                    })
                }

                results.informationMessages = []
                response.data.informations.filter(item => { return item.type == 'I' }).forEach(item => {
                    results.informationMessages.push(item.message)
                })
                commit('setResults', results)
                commit('setState', 'after')
            }
            commit('setRunning', false)
        })
        .catch(error => {
            commit('setRunning', false)
            commit('pushError', resources.standardErrorMessage)
        })
    }
}

export default ApiService


// WEBPACK FOOTER //
// ./src/helpers/common.services.js